import React, { Component } from "react";
import { classnames, Icon } from "@culturehq/components";

class FeedFilterAccordian extends Component {
  constructor(props) {
    super(props);

    const { initialOpen } = props;

    this.state = {
      open: initialOpen,
      search: "",
      searchOpen: false
    };
  }

  componentDidUpdate(prevProps, prevState) {
    const { onScroll, onSearch } = this.props;
    const { open, search } = this.state;

    if (search !== prevState.search) {
      onSearch(search);
    }

    if (onScroll && open !== prevState.open && open) {
      onScroll();
    }
  }

  handleToggle = () => {
    this.setState(({ open }) => {
      if (open) {
        return { open: false, searchOpen: false };
      }
      return { open: true };
    });
  };

  handleSearch = ({ target: { value: search } }) => {
    this.setState({ search });
  };

  handleSearchToggle = event => {
    event.stopPropagation();

    this.setState(({ searchOpen }) => {
      if (searchOpen) {
        return { search: "", searchOpen: false };
      }
      return { open: true, searchOpen: true };
    });
  };

  handleScroll = event => {
    const { onScroll } = this.props;
    const { target } = event;

    if (onScroll && target.scrollTop + target.offsetHeight + 50 >= target.scrollHeight) {
      onScroll();
    }
  };

  render() {
    const { className, onSearch, title, children } = this.props;
    const { open, search, searchOpen } = this.state;

    return (
      <div className={classnames("FeedFilterAccordian", "clearfix", className)}>
        <span className="FeedFilterAccordian__title no-select clickable" onClick={this.handleToggle}>
          {onSearch && (
            <span onClick={this.handleSearchToggle}>
              <Icon icon={searchOpen ? "reply" : "search"} />
            </span>
          )}
          <h2>{title}</h2>
        </span>

        {onSearch && searchOpen && (
          <div className="FeedFilterAccordian__body">
            <input
              type="text"
              className="form-control"
              placeholder="Search"
              value={search}
              onChange={this.handleSearch}
            />
          </div>
        )}

        <div
          className={`FeedFilterAccordian__body ${open ? "open" : "closed"}`}
          onScroll={this.handleScroll}
        >
          {children}
        </div>
      </div>
    );
  }
}

export default FeedFilterAccordian;
